import React from "react"
import "../assets/style.scss"
import {Link} from "gatsby";
import Upaep from "../assets/svg/upaep.inline.svg"
import UpaepWhite from "../assets/svg/upaep_white.inline.svg"
import RioArrote from "../assets/svg/rio_arronte.inline.svg"

export default function Layout({children, fullHeader = true}) {
    return (
        <>

            <header>
                <div className="top">
                    <Link to={'/'} className="logo">
                        <Upaep/>
                    </Link>
                </div>
                {fullHeader &&
                    <>
                        <div className="middle">
                            <h1>Transformo mi comunidad en lengua indígena: Programa de formación de enfermeras a nivel
                                licenciatura.</h1>
                        </div>
                        <div className="bottom">
                            <Link to={'/'}><Upaep/></Link>
                            <Link to={'/'}><RioArrote/></Link>
                        </div>
                        <div className="last">
                            <p>El proyecto "Transformo mi comunidad en lengua indígena” nace del programa de formación de
                                enfermeras a nivel licenciatura en modalidad abierta de la UPAEP. Su objetivo es promover el
                                bien común mediante la construcción de una medicina comunitaria en diferentes lenguas indígenas,
                                incentivando así la participación ciudadana al autocuidado de la salud y contribuyendo a la
                                preservación cultural que distingue a México. De esta forma, y tras la búsqueda de generar un
                                impacto social, se apostó por un sistema de trabajo comunitario a favor de los pueblos indígenas
                                con el fin de fortalecer una medicina preventiva incluyente.
                                <br/>
                                A continuación, se presenta el resultado de un esfuerzo colaborativo por parte de la comunidad
                                educativa universitaria con el valioso apoyo de la Fundación Gonzalo Río Arronte.</p>
                        </div>
                    </>
                }
            </header>

            <main>
                {children}
            </main>
            <footer>
                <UpaepWhite/>
                <p>Transformo mi comunidad en <b>lengua indígena</b>: Programa de formación de enfermeras a nivel
                    licenciatura. Todos los derechos reservados {new Date().getFullYear()}. </p>
            </footer>
        </>
    )
}
